export default function routing($stateProvider) {
    $stateProvider.state('setting', {
            url: '/settings',
            abstract: true
        }).state('setting.folder', {
            url: '/{folder}',
            controller: 'SettingCtrl',
            controllerAs: 'index',
            template: require('../../../views/setting/index.html')
        })
}

routing.$inject = ['$stateProvider'];